// types
import { WSExamConsultantEventActionProps, WSCheckoutEventActionProps, WSSignsSymptomsEventActionProps, WSExamAnalysisEventActionProps, WSChatEventActionProps } from '@/types/ws-types'

// variables
export const WS_EXAM_CONSULTANT_EVENTS: Record<WSExamConsultantEventActionProps, WSExamConsultantEventActionProps> = {
  EXAM_CONSULTANT_DONE: 'EXAM_CONSULTANT_DONE',
  EXAM_CONSULTANT_FAIL: 'EXAM_CONSULTANT_FAIL'
}

export const WS_CHECKOUT_EVENTS: Record<WSCheckoutEventActionProps, WSCheckoutEventActionProps> = {
  CHECKOUT_PAID: 'CHECKOUT_PAID',
  CHECKOUT_FAILED: 'CHECKOUT_FAILED',
  CHECKOUT_REFUNDED: 'CHECKOUT_REFUNDED'
}

export const WS_SIGNS_SYMPTOMS_EVENTS: Record<WSSignsSymptomsEventActionProps, WSSignsSymptomsEventActionProps> = {
  SIGNS_SYMPTOMS_ANALYSIS_DONE: 'SIGNS_SYMPTOMS_ANALYSIS_DONE',
  SIGNS_SYMPTOMS_ANALYSIS_FAIL: 'SIGNS_SYMPTOMS_ANALYSIS_FAIL'
}

export const WS_EXAM_ANALYSIS_EVENTS: Record<WSExamAnalysisEventActionProps, WSExamAnalysisEventActionProps> = {
  EXAM_ANALYSIS_DONE: 'EXAM_ANALYSIS_DONE',
  EXAM_ANALYSIS_FAIL: 'EXAM_ANALYSIS_FAIL'
}

export const WS_CHAT_EVENTS: Record<WSChatEventActionProps, WSChatEventActionProps> = {
  NINA_CHAT_CHUNK: 'NINA_CHAT_CHUNK',
  NINA_CHAT_DONE: 'NINA_CHAT_DONE',
  NINA_CHAT_FAIL: 'NINA_CHAT_FAIL',
  NINA_CHAT_STOP_REQUEST: 'NINA_CHAT_STOP_REQUEST',
  NINA_CHAT_STOPPED: 'NINA_CHAT_STOPPED',
}
